export default __webpack_public_path__ + "static/media/chatgpt.8cc48000.png";